import React, { useState } from 'react';

import {
    ArrowUpSLineIcon,
    ArrowDownSLineIcon,
    DeleteBin4LineIcon,
} from '../../../../design-system/Icons';
import { ButtonIcon, SvgIcon } from '../../../../design-system';
import PromptEditorModal from '../PromptEditorModal/PromptEditorModal';
import EditLineIcon from '../../../../design-system/Icons/EditLineIcon';
import DeletePromptModal from '../DeletePromptModal/DeletePromptModal';
import ChatSmile2LineIcon from '../../../../design-system/Icons/ChatSmile2LineIcon';

const PromptCard = ({ prompt, isEditable, setPrompts }) => {
    const { id, name, description, text } = prompt;

    const [actionModal, setActionModal] = useState({ action: null });
    const [isExpanded, setIsExpanded] = useState(false);

    const closeActionModal = () => setActionModal({ action: null });

    const icon = isExpanded ? ArrowUpSLineIcon : ArrowDownSLineIcon;

    return (
        <li className="px-3 xs:px-4 py-3 rounded-2 border-1 border-neutral-200 flex flex-col gap-4">
            <div className="flex flex-row items-center justify-between gap-y-2 gap-x-2 xs:gap-x-3 md:gap-x-4">
                <div className="overflow-hidden">
                    <div className="flex items-start gap-2 mb-0.5">
                        <SvgIcon color="#1F2125" icon={ChatSmile2LineIcon} size="medium" />
                        <p className="flex items-center font-body-bold text-body-bold-xs text-black min-h-[16px]">
                            {name}
                        </p>
                    </div>

                    <p className="font-body text-body-regular-xs text-neutral-500 truncate">
                        {description}
                    </p>
                </div>

                <ButtonIcon
                    type="neutral"
                    size="sm"
                    icon={icon}
                    onClick={() => setIsExpanded((prev) => !prev)}
                />
            </div>

            {isExpanded && (
                <div className="flex flex-col gap-3">
                    <p className="font-body text-body-regular-xs text-neutral-300 uppercase">
                        Prompt
                    </p>

                    <p className="whitespace-pre-wrap px-2.5 py-3 xs:px-3 xs:py-[18px] min-h-[50px] rounded-2 border border-neutral-200 bg-neutral-50 font-body text-body-regular-m text-neutral-300">
                        {text}
                    </p>

                    {isEditable && (
                        <div className="flex items-center justify-end gap-2.5">
                            <ButtonIcon
                                type="link"
                                size="xs"
                                icon={EditLineIcon}
                                onClick={() => setActionModal({ action: 'edit' })}
                            />
                            <ButtonIcon
                                type="link"
                                size="xs"
                                state={isEditable ? 'default' : 'disabled'}
                                icon={DeleteBin4LineIcon}
                                onClick={() => setActionModal({ action: 'delete' })}
                            />
                        </div>
                    )}
                </div>
            )}

            {actionModal.action === 'edit' && (
                <PromptEditorModal
                    mode="edit"
                    data={{ id, name, description, prompt: text }}
                    setPrompts={setPrompts}
                    onClose={closeActionModal}
                />
            )}

            {actionModal.action === 'delete' && (
                <DeletePromptModal
                    id={id}
                    name={name}
                    setPrompts={setPrompts}
                    onClose={closeActionModal}
                />
            )}
        </li>
    );
};

export default PromptCard;
